import * as $ from 'jquery';

let MapboxGL;
let orderCompletedAt;
let tracking = {
    markers: {}
};

/*
 * Safari can't parse normal, standard datetime formats for some reason
 * https://stackoverflow.com/questions/6427204/date-parsing-in-javascript-is-different-between-safari-and-chrome
 */
function parseDate(datetimeString) {
    const splitDate = datetimeString.split(/[^0-9]/);
    return new Date (splitDate[0], splitDate[1]-1, splitDate[2], splitDate[3], splitDate[4], splitDate[5]);
}

function div(className) {
    let div = document.createElement('div');
    div.className = className;
    return div;
}

function toRad(value) {
    return value * Math.PI / 180;
}

function newCarMarker(location) {
    const car = new MapboxGL.Marker(div('tracking-car-position-marker'));
    car.setLngLat(location);
    return car;
}

function hasCourierArrived() {
    return 100 >= calculateDistance(tracking.markers.destination.getLngLat(), tracking.markers.car.getLngLat());
}

function setCarAngle(car, newLocation) {
    const previousLocation = tracking.markers.car.getLngLat();
    const lngDiff = newLocation.lng - previousLocation.lng;
    const latDiff = newLocation.lat - previousLocation.lat;
    const angle = Math.floor((Math.atan2(lngDiff, latDiff) * 180 / Math.PI)) + 90;
    tracking.markers.car.setRotation(angle);
}

function newMap(mapCenter, mapBoxToken) {
    MapboxGL.accessToken = mapBoxToken;
    const map = new MapboxGL.Map({
        container: 'order-shipping-car-position-map',
        style: 'mapbox://styles/mapbox/light-v10',
        center: mapCenter,
        zoom: 8,
        showZoom: true,
        interactive: false,
        pitchWithRotate: false,
        dragRotate: false,
        touchZoomRotate: false
    });
    map.addControl(new MapboxGL.NavigationControl(), 'top-left');

    return map;
}

function calculateDistance(coordinates1, coordinates2) {
    let lat1 = coordinates1.lat,
        lng1 = coordinates1.lng,
        lat2 = coordinates2.lat,
        lng2 = coordinates2.lng,
        dLat = toRad(lat2 - lat1),
        dLng = toRad(lng2 - lng1),
        a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(toRad(lat1)) * Math.cos(toRad(lat2))

    return  2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)) * 1000 * 6378;
}

function fitBounds(tracking, options = {}){
    let bounds = new MapboxGL.LngLatBounds();
    if (tracking.markers.destination) {
        bounds.extend(tracking.markers.destination.getLngLat());
    }

    if (tracking.markers.car && tracking.markers.car) {
        bounds.extend(tracking.markers.car.getLngLat());
    } else if (!tracking.markers.carArrived.getLngLat()) {
        bounds.extend(tracking.markers.branch.getLngLat());
    }

    tracking.map.fitBounds(
        bounds,
        Object.assign(options, {
            animation: false,
            linear: true,
            padding: {
                top: 100,
                bottom: 60,
                left: 100,
                right:100
            }
        })
    );
}

function transitionStateToArrived() {
    $.ajax({
        method: 'PATCH',
        url: tracking.config.arriveTransitionUrl
    });
}

function getTimeLabel(type, count)
{
    return tracking.config.texts[type].filter((label => label.count <= count)).shift().label;
}

function formatDeliveryAtLabel(estimatedDeliveryAt, remainingMilliseconds)
{
    let label = '';
    let date = new Date(remainingMilliseconds + ((new Date(remainingMilliseconds)).getTimezoneOffset() * 60 * 1000));
    let hours = date.getHours();
    let minutes = date.getMinutes();
    minutes = (minutes < 1 && hours > 0) ? undefined : minutes;

    if (hours > 0) {
        label = (new Intl.DateTimeFormat(tracking.config.locale, { timeStyle: 'short' })).format(estimatedDeliveryAt);
    } else if (Number.isInteger(minutes)) {
        if (label !== '') {
            label += ' ' + tracking.config.texts.and + ' ';
        }
        label += ' ' + minutes + ' ' + '<small>' + getTimeLabel('minutes', minutes) + '</small>';
    }

    return label.trim();
}

function refreshEstimatedArrival(estimatedDeliveryAt) {
    let arrivingAt = estimatedDeliveryAt - new Date();

    if (arrivingAt < 0) {
        arrivingAt = 0;
        estimatedDeliveryAt = new Date();
    }

    let shippingSpan = estimatedDeliveryAt - orderCompletedAt;
    let progress = Math.round((1 - (arrivingAt / shippingSpan)) * 100);
    $('#courier-arrival-progress-bar').css('width', progress + '%');
    let deliveryAtLabel = formatDeliveryAtLabel(estimatedDeliveryAt, arrivingAt);
    let deliveryAtElement = $('#delivery-in-minutes');

    if (deliveryAtLabel) {
        deliveryAtElement.parent().hasClass('hidden') && deliveryAtElement.parent().removeClass('hidden');
        deliveryAtElement.html(deliveryAtLabel);
    } else {
        deliveryAtElement.parent().hasClass('hidden') || deliveryAtElement.parent().addClass('hidden');
    }
}

function addCarArrivedMarkerToMap() {
    tracking.markers.carArrived.setLngLat(tracking.markers.destination.getLngLat());
    tracking.markers.carArrived.addTo(tracking.map);
    tracking.map.setCenter(tracking.markers.destination.getLngLat());
}

function processNewCarLocation(data) {
    if (data.Lat &&
        data.Lon &&
        data.State === tracking.config.triggerState
    ) {
        const newCarLocation = {lng: data.Lon, lat: data.Lat};

        if (!tracking.markers.car) {
            const car = newCarMarker(newCarLocation);
            car.addTo(tracking.map);
            tracking.markers.car = car;
        } else {
            setCarAngle(tracking.markers.car, newCarLocation);
            tracking.markers.car.setLngLat(newCarLocation);
        }

        if (hasCourierArrived()) {
            tracking.markers.car.remove();
            addCarArrivedMarkerToMap();
            tracking.markers.car = null;
            if (tracking.config.arriveTransitionUrl) {
                transitionStateToArrived();
                return true;
            }
        }

        fitBounds(tracking);
    }

    if (data.DestinationArrivalEstimateAt) {
        const arrivalEstimateAt = parseDate(data.DestinationArrivalEstimateAt);
        refreshEstimatedArrival(arrivalEstimateAt);
    }
}

function trackCarPosition() {
    const interval = setInterval(function () {
        $.ajax({
            url: tracking.config.carPositionUrl,
            method: 'get',
            crossDomain: true
        }).done((response, textStatus, xhr) => {
            if (401 === xhr.status) {
                location.reload();
                return;
            }
            if (!response || (Array.isArray(response) && !response.length)) {
                return;
            }
            if (processNewCarLocation(response)) {
                clearInterval(interval);
            }
        }).fail(function(){
            location.reload();
        });
    }, tracking.config.refreshInterval);
}

export function init(mapboxgl, root) {
    MapboxGL = mapboxgl;

    const initData = root.data('tracking-init');
    orderCompletedAt = new Date(initData.orderCompletedAt);
    tracking.root = root;
    tracking.config = root.data('tracking-config');
    tracking.map = newMap(initData.branch, tracking.config.mapBoxToken);

    const branch = new MapboxGL.Marker(div('tracking-branch-marker'));
    const destination = new MapboxGL.Marker(div('tracking-target-marker'));
    const carArrived = new MapboxGL.Marker(div('tracking-car-arrived-marker'));

    branch.setLngLat(initData.branch);
    branch.addTo(tracking.map);

    tracking.markers.carArrived = carArrived;
    tracking.markers.branch = branch;

    if (initData.destination) {
        destination.setLngLat(initData.destination);
        destination.addTo(tracking.map);
        tracking.markers.destination = destination;
    } else {
        fitBounds(tracking, { maxZoom: 15 })
    }

    if (initData.courierHasArrived) {
        addCarArrivedMarkerToMap();
        fitBounds(tracking, { maxZoom: 20 });
    } else if (initData.car) {
        const car = newCarMarker(initData.car);
        car.addTo(tracking.map);
        tracking.markers.car = car;
        fitBounds(tracking);
    } else {
        fitBounds(tracking, { maxZoom: 15 });
    }

    if (initData.personalPickUpAt) {
        const pickUpAt = parseDate(initData.personalPickUpAt.date);

        refreshEstimatedArrival(pickUpAt);
        const refreshInterval = setInterval(() => {
            refreshEstimatedArrival(pickUpAt);
            if (!document.getElementById('delivery-in-minutes')) {
                clearInterval(refreshInterval);
            }
        }, 1000);
    }

    if (initData.destination) {
        trackCarPosition();
    }
}
